import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { noop } from 'lodash';
import { UploadOutlined, FileImageOutlined } from '@ant-design/icons';

import { getBase64 } from '../../../shared/utils';

import {
  HeaderImagePreviewContainer,
  HeaderImagePreview,
  HeaderImage,
  UploadStyled,
  ImageUploadContainer,
} from './styled';

interface IconUploadProps {
  onChange?: (file: any) => void;
  uploadButtonText?: string;
  value?: string;
}

export const IconUpload: FC<IconUploadProps> = ({
  onChange = noop,
  value = '',
  uploadButtonText = 'SVG Datei hochladen',
}) => {
  const [preview, setPreview] = useState<any>(value);

  /**
   * customRequest
   *
   *  This function tricks ant upload field buildin ajax request (we use graphql).
   */
  const customRequest = ({ onSuccess }: any) => {
    setTimeout(() => onSuccess('ok'));
  };

  /**
   * onFileChange
   */
  const onFileChange = async ({ file }: any) => {
    onChange(file.originFileObj);

    if (file) {
      const base64 = await getBase64(file.originFileObj);

      setPreview(base64);
    } else {
      setPreview(null);
    }
  };

  return (
    <ImageUploadContainer>
      <HeaderImagePreviewContainer>
        <HeaderImagePreview>
          {!preview && (
            <FileImageOutlined
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate3d(-50%, -50%, 0)',
                fontSize: 14,
                color: '#ccc',
              }}
            />
          )}

          {preview && <HeaderImage src={preview} />}
        </HeaderImagePreview>
      </HeaderImagePreviewContainer>

      <UploadStyled
        onChange={onFileChange}
        customRequest={customRequest}
        multiple={false}
        accept="image/svg+xml"
      >
        <Button type="link">
          <UploadOutlined /> {uploadButtonText}
        </Button>
        min. 36x36 px
      </UploadStyled>
    </ImageUploadContainer>
  );
};
